export function isAbsoluteUrl(value) {
    return typeof value === "string" && /^https?:\/\//i.test(value);
}

export function buildStorageAssetUrl(endpoint, bucket, directory, file) {
    if (typeof file !== "string" || file.trim() === "") {
        return "";
    }

    if (isAbsoluteUrl(file)) {
        return file;
    }

    const normalizedFile = file.replace(/^\/+/, "");
    const normalizedEndpoint =
        typeof endpoint === "string" ? endpoint.replace(/\/+$/, "") : "";
    const normalizedBucket =
        typeof bucket === "string" ? bucket.replace(/^\/+|\/+$/g, "") : "";
    const normalizedDirectory =
        typeof directory === "string"
            ? directory.replace(/^\/+|\/+$/g, "")
            : "";

    if (normalizedEndpoint === "" || normalizedBucket === "") {
        return normalizedFile;
    }

    return [
        normalizedEndpoint,
        normalizedBucket,
        normalizedDirectory,
        normalizedFile,
    ]
        .filter(Boolean)
        .join("/");
}

export function buildLinkAssetUrl(endpoint, bucket, file) {
    return buildStorageAssetUrl(endpoint, bucket, "links", file);
}
